// Classe para retornar data formatada em vários formatos

export default class ConvertDate {
  parseDateToMonthYearText(dataEntrega: string): string {
    const date = new Date(dataEntrega);
    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

    const formattedDate = `${meses[date.getMonth()]} de ${date.getFullYear()}`;

    return formattedDate; // agosto de 2026
  }

  parseDateToMonthYear(dataEntrega: string): string {
    const [dia, mes, ano] = dataEntrega.split('/');

    const date = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));

    const formattedDate = `${mes}/${date.getFullYear()}`;

    return formattedDate; // 08/2026
  }
}
